import React from 'react';

export const LayoutContent: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return <div className="flex flex-col flex-1 gap-4">{children}</div>;
};
